import React from "react";
import HttpRequest from "helper-xhr";
import { Pagination } from "./pagination.jsx";
import { Localize } from "../shared/localize.js";

class WheelsLoadMore extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    var button = null;
    var textA = <span>{this.props.hmWheelsDisplayedSoFar} {Localize.L("risultati mostrati nella pagina")}</span>;
    var textB = null;
    if (this.props.hmFilteredWheelsForThisCar > this.props.hmWheelsDisplayedSoFar) {
      textB = <span>, {Localize.L("ci sono")} {this.props.hmFilteredWheelsForThisCar} {Localize.L("risultati in base ai filtri da te impostati")}</span>;
      button = (<a className="btn btn-light btn-big-enough" onClick={(e) => this.props.handleClick()}>{Localize.L("Mostra ulteriori risultati...")}</a>);
    }
    //var textC = null;
    //if (this.props.hmTotalWheelsForThisCar > this.props.hmFilteredWheelsForThisCar) {
    //  textC = <span>e {this.props.hmTotalWheelsForThisCar} risultati totali per la tua auto</span>;
    //}
    //{ textC }

    if (this.props.hideLoadMore || false) {
      return "";
    }

    return (
      <div>
        <div style={{ marginTop: 20, marginBottom: 20, textAlign: "center" }}>
          <div style={{ padding: 10 }}>
            {textA}
            {textB}
          </div>
          {button}
        </div>
        {1 == 2 ? <Pagination pages={this.state.pages} /> : null}
      </div>
    );
  }
}

export { WheelsLoadMore };